import React from 'react';

export const CURSOR_COLORS = {
  BLUE: '0,58,255',
  WHITE: '255,255,255',
};

const SiteContext = React.createContext(null);
export default SiteContext;
